import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/spots/east-sea/page.tsx");
